export default __webpack_public_path__ + "static/media/add-spice-rack.06befc3f.svg";